import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			height: 0,
			position: 'relative',
		},
		addSection: {
			position: 'absolute',
			top: 0,
			[theme.breakpoints.down('md')]: {
				top: ({ offset }) => (offset ? theme.spacing(offset / 18) : 0),
			},
			[theme.breakpoints.up('md')]: {
				top: ({ offset }) => (offset ? theme.spacing(offset / 10) : 0),
			},
			right: '50%',
			padding: 0,
			zIndex: 12,
			transform: `translate(50%, ${theme.spacing(-1.6)})`,
			backgroundColor: theme.palette.scoreapp.primary,
			width: theme.spacing(3),
			height: theme.spacing(3),
			borderRadius: '50%',
			minWidth: 0,
			color: theme.palette.scoreapp.background,
			'&:hover': {
				backgroundColor: theme.palette.scoreapp.primary,
			},
		},
	}),
	{ name: 'AddSection' },
)

export default useStyles
